import React from "react";
import { Stream } from "@cloudflare/stream-react";

const CloudflareStreamPlayer = ({
                                  videoId,
                                  onVideoEnded,
                                  streamRef,
                                  width = "100%",      // 기본 width
                                  height = "100%",     // 기본 height
                                  aspectRatio = "16/9", // 기본 비율
                                  controls = true,
                                  onCanPlayThrough,
                                  onTimeUpdate,
                                  className = ""
                                }) => {

  return (
    <div
      className="stream-wrapper"
      style={{
        width,
        aspectRatio,
        maxWidth: "100%",   // 필요하면 제한
        margin: "0 auto"
      }}
    >
      <Stream
        streamRef={streamRef}
        src={videoId}
        onEnded={() => onVideoEnded?.()}
        autoPlay
        muted={false}
        playsInline
        controls={controls}
        controlsList="nodownload"
        disablePictureInPicture
        className={`stream-player ${className}`}
        style={{ width: "100%", height: "100%" }}
        onCanPlayThrough={onCanPlayThrough}
        onTimeUpdate={onTimeUpdate}
      />
    </div>
  );
};

export default CloudflareStreamPlayer;
